import { render, staticRenderFns } from "./merge-vehicle.vue?vue&type=template&id=4a86acd5&scoped=true&"
import script from "./merge-vehicle.vue?vue&type=script&lang=js&"
export * from "./merge-vehicle.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a86acd5",
  null
  
)

export default component.exports